import React from 'react';
import ReactDatePicker from 'react-datepicker';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TherapistDashboardSchedule, TherapistDashboardOutstandingNotes } from 'TherapistDashboard'
import { dashboardActions } from '_actions';
import styles from './TherapistDashboard.module.css'
import { CheckBox } from '_components';
import { CommonButton } from '_components';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
class TherapistDashboard extends React.Component {

    refreshSchedulesWithNotes() {
        this.props.loadSchedule(this.props.scheduleDate);
        this.props.loadOutstandingNotes();
    }

    toggleCxNsStatus() {
        this.props.showHideCxNs();
    }

    toggleUnavailableBlocksStatus() {
        this.props.showHideUnavailable();
    }

    handleScheduleDateChange(date) {
        this.props.loadSchedule(date);
    }

    handleDateChangeRaw = (e) => {
        e.preventDefault();
    }

    render() {
        return (
            <div className={styles.therapist_dashboard}>
                <div className={styles.schedule_container}>
                    <div className={styles.status_cxns}>
                        <CheckBox
                            label='Include CX/NS'
                            checked={this.props.showCxNs}
                            onClick={() => this.toggleCxNsStatus()}
                        />
                    </div>
                    <div className={styles.status_blocks}>
                        <CheckBox
                            label='Include Unavailable Blocks'
                            checked={this.props.showUnavailable}
                            onClick={() => this.toggleUnavailableBlocksStatus()}
                        />
                    </div>
                    <div className={styles.schedule_date}>
                        <div className={styles.picker_wrapper}>
                            <ReactDatePicker
                                className={styles.picker}
                                selected={this.props.scheduleDate}
                                onChange={(date) =>  this.handleScheduleDateChange(date)}
                                onChangeRaw={this.handleDateChangeRaw}
                                dateFormat='EEEE, MMMM d, yyyy'
                                todayButton='Today'
                            />
                        </div>
                       
                    </div>
                    <div className={styles.refresh_container}>
                    <CommonButton className={styles.refresh_button} size='smaller' title='Refresh Schedule' onClick={() => this.refreshSchedulesWithNotes()}><FontAwesomeIcon icon={faRefresh} color="white"></FontAwesomeIcon></CommonButton>
                    </div>
                </div>

                <div className={styles.schedule_outstanding_notes_wrapper}>
                    <div className={styles.schedule_table_large}>
                        <TherapistDashboardSchedule />
                    </div>
                    <div className={styles.outstanding_notes}>
                        <TherapistDashboardOutstandingNotes />
                    </div>
                </div>
            </div >
        );
    }
}



function mapDispatchToProps(dispatch) {
    return {
        loadSchedule: bindActionCreators(dashboardActions.loadSchedule, dispatch),
        loadOutstandingNotes: bindActionCreators(dashboardActions.loadOutstandingNotes, dispatch),
        showHideCxNs: bindActionCreators(dashboardActions.showHideCxNs, dispatch),
        showHideUnavailable: bindActionCreators(dashboardActions.showHideUnavailable, dispatch),
    };
}

function mapStateToProps(state) {
    let appts = Object.keys(state.entities.dashboard.schedule)
        .sort((a, b) => {
            if (state.entities.dashboard.schedule[a].APTSTART !== state.entities.dashboard.schedule[b].APTSTART) {
                return state.entities.dashboard.schedule[a].APTSTART - state.entities.dashboard.schedule[b].APTSTART;
            } else if (state.entities.dashboard.schedule[a].APTSTART === state.entities.dashboard.schedule[b].APTSTART &&
                state.entities.dashboard.schedule[a].APTDURATION !== state.entities.dashboard.schedule[b].APTDURATION) {
                return state.entities.dashboard.schedule[a].APTDURATION - state.entities.dashboard.schedule[b].APTDURATION;
            } else {
                return state.entities.dashboard.schedule[a].APTID - state.entities.dashboard.schedule[b].APTID;
            }
        })
        .filter((x) => {
            if (state.ui.dashboard.showCxNs) {
                return state.entities.dashboard.schedule[x].ADTASID !== 4 && state.entities.dashboard.schedule[x].ADTASID !== 5
            } else {
                return true;
            }

        })
        .map(x => state.entities.dashboard.schedule[x]);

    let showCxNs = state.ui.dashboard.showCxNs;
    let showUnavailable = state.ui.dashboard.showUnavailable;

    return {
        scheduleDate: state.ui.dashboard.date,
        appts,
        showCxNs,
        showUnavailable,
    };
}

const connectedTherapistDashboard = connect(mapStateToProps, mapDispatchToProps)(TherapistDashboard);
export { connectedTherapistDashboard as TherapistDashboard };
